import { render, staticRenderFns } from "./SfColorPicker.vue?vue&type=template&id=68379f84&"
import script from "./SfColorPicker.vue?vue&type=script&lang=js&"
export * from "./SfColorPicker.vue?vue&type=script&lang=js&"
import style0 from "./SfColorPicker.vue?vue&type=style&index=0&id=68379f84&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports